export default "/images/portal156.png?f664802594daef7bc9350308b1cc82fe";